var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-navigation-drawer',{attrs:{"app":"","clipped":""}},[_c('v-list',_vm._l((_setup.items),function(item){return _c('v-list-item',{key:item.title,attrs:{"link":"","to":item.route}},[_c('v-list-item-content',[_vm._v(" "+_vm._s(item.title)+" ")])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }